import React__default from 'react';

const SelectOption = ({ value, label, disabled = false, hidden = false, }) => {
    return (React__default.createElement("option", { value: value, disabled: disabled, hidden: hidden }, label));
};

export { SelectOption as default };
//# sourceMappingURL=SelectOption.js.map
